<div class="pointCF__field">
  <label class="pointCF__label">
    <div class="pointCF__label-image--container">
      <pp-icon [ppSrc]="EIconPath.ICON_FIELDS_FORMULA_18" ppColor="inherit" ppClass="setSize18" />
    </div>

    <span
      ppTooltip
      [ppTitle]="ppFieldLabel"
      [ppTrimTooltip]="true"
      class="pointCF__label-container"
      >
      {{ ppFieldLabel }}
    </span>

    @if (ppFieldDescription) {
      <pp-point-fields-custom-field-description
        [ppDescription]="ppFieldDescription"
      ></pp-point-fields-custom-field-description>
    }
  </label>

  <div class="pointCF__formulaWrapper">
    <div class="pointCF__formulaContent">
      @if (unitSymbol) {
        <span
          class="customFieldNumeric__unitWrapper"
          ppTooltip
          [ppTitle]="unitSymbolTooltip"
          >
          <span class="customFieldNumeric__unit">
            {{ unitSymbol }}
          </span>
        </span>
      }

      <div
        ppTooltip
        [ppSanitize]="false"
        [ppTitle]="tooltipTitle"
        class="pointCF__formula"
        [class.pointCF__formula--borderLeft]="!!unitSymbol"
        >
        {{ value }}
      </div>
    </div>
  </div>
</div>
